var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.84 1.259A.75.75 0 1011.738.24l-1.442 1.562L7.27 5.079a4.362 4.362 0 00-2.674-.914C2.002 4.165 0 6.423 0 9.08s2.002 4.915 4.596 4.915c2.594 0 4.597-2.258 4.597-4.915a5.145 5.145 0 00-.891-2.907l2.545-2.756L12.7 5.424a.75.75 0 101.102-1.018l-1.934-2.094.972-1.053zM1.5 9.08c0-1.943 1.44-3.415 3.096-3.415 1.655 0 3.097 1.472 3.097 3.415s-1.442 3.415-3.097 3.415S1.5 11.023 1.5 9.08z",
    fill: "currentColor"
  })));
}
export default SvgKey;